// https://vuex.vuejs.org/en/state.html
export default {
    fetching : false,
    buttons : {
        save : false,
    },
  
    userProfile : {},
    invoices : [],
    sidebar : false,
    e1 : 1,
    avatar : {
        url : "",
        show : false,     
    },
    user :{},
    modal : {
        show : false, 
        title : "", 
        content : "", 
        url : null,
        password : false
    },
    snack: {
        show : false,
        color :"",
        text: "",
    } ,
    showNavActionButtons : false,
    invoice: {
        number:1,
        have_due_date : false,
        logo :"",
        type : "",
        date : new Date().toISOString().substr(0, 10),
        dueDate : new Date((new Date()).getTime() + (60*60*24*1000)).toISOString().substr(0, 10),
        dialog: false,
        taxTypes: ["rate", "amount"],
        currencies: ["DZD", "USD", "EUR"],
        snack: false,
        snackColor: "",
        snackText: "",
        items : [],
        taxes : [],
        from : {
            name :'',
            email:'',
            address:"",
            details :""
        },
        to : {
            name :'',
            email:'',
            address:"",
            details :""
        },
        is_private: false,
        password: "",
        user_id :"",
        sub_total: 0,
        total: 0,
    }
}